import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Toaster, toast } from "sonner";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    if (user) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const res = await login(email, password);
        setSubmitting(false);
        if (res.ok) {
            toast.success("Connexion réussie");
            navigate("/admin");
        } else {
            toast.error(res.error || "Échec de la connexion");
        }
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-grain px-4"
            data-testid="admin-login-page"
        >
            <Toaster richColors position="top-center" />
            <div className="w-full max-w-md brand-card p-8">
                <p className="section-tag text-center">espace privé</p>
                <h1 className="font-serif-display text-3xl text-[#2A1408] text-center">
                    Connexion administration
                </h1>
                <p className="text-center text-sm text-[#5C3D2E] mt-2">
                    Accès réservé à l’équipe Le Comptoir du Cookie.
                </p>
                <form onSubmit={onSubmit} className="mt-6 space-y-4">
                    <label className="block text-xs uppercase tracking-widest text-[#5C3D2E]">
                        Email
                        <input
                            required
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 w-full bg-white border border-[#E4D1BB] rounded-md px-3 py-2 text-sm"
                            data-testid="login-email"
                        />
                    </label>
                    <label className="block text-xs uppercase tracking-widest text-[#5C3D2E]">
                        Mot de passe
                        <input
                            required
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 w-full bg-white border border-[#E4D1BB] rounded-md px-3 py-2 text-sm"
                            data-testid="login-password"
                        />
                    </label>
                    <button
                        type="submit"
                        disabled={submitting}
                        className="brand-btn w-full"
                        data-testid="login-submit"
                    >
                        {submitting ? "Connexion…" : "Se connecter"}
                    </button>
                </form>
            </div>
        </div>
    );
}
